import React, { Component } from "react";
import __ from "lodash";
import { connect } from "react-redux";
import { cekCookies } from "../../../../../actions";
import LoaderModal from "../../../../modal/LoaderModal";
import { CONFIG } from "../../../../../config";
import accountManagement from "../../../../../apis/accountManagement";
import { Row, Col, Alert, Table } from "react-bootstrap";
import "./circlebar.css";
import "./reportsbmptn.css";
import { TableHead, TableRow, TableCell, TableBody } from "@material-ui/core";

class SbmptnSekolah extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            showIndikator: false,
            jumMapel: null,
            dataMapel: null,
            detail: {},
            siswa: {},
            skorNonCampuran: {},
            skorSaintek: {},
            skorSoshum: {},
            dataAll: [],
        };
    }

    async componentDidMount() {
        document.title = "Report SBMPTN";
        this.setState({ isFetching: true });
        await this.props.cekCookies();
        if (!__.isEmpty(this.props.account)) {
            this.fetchData();
        }
    }

    fetchData = async () => {
        const param = this.props.match.params;
        let qString = {
            idSekolah: this.props.account.idSekolah,
            idKelas: param.idKelas,
            idJadwal: param.idJadwal,
            kelompok: param.kelompok,
        };

        const response = await accountManagement
            .get(CONFIG.REPORT_CBT_SBMPTN, {
                params: qString,
            })
            .catch(function (error) {
                console.log(error);
            });
        if (response) {
            if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    detail: response.data.data.detail,
                    siswa: response.data.data.siswa,
                    dataMapel: response.data.data.mapel,
                    skorNonCampuran: response.data.data.skorNonCampuran,
                    skorSaintek: response.data.data.skorSaintek,
                    skorSoshum: response.data.data.skorSoshum,
                    jumMapel: response.data.data.jumMapel,
                    dataAll: response.data.data.resultAll,
                });
            }
            this.setState({ isFetching: false });
        }
        this.setState({ isFetching: false });
    };

    renderTableParent() {
        let { dataMapel, siswa, dataAll, skorNonCampuran, skorSaintek, skorSoshum, jumMapel, detail } = this.state;
        if (!__.isEmpty(dataAll)) {
            return (
                <Table className="table table-bordered">
                    <TableHead>
                        <TableRow>
                            <TableCell className="table-font-kecil">No.</TableCell>
                            <TableCell className="table-font-kecil">Nama Siswa</TableCell>
                            {dataMapel.map((mapel, mp) => (
                                <TableCell key={mp} className="table-font-kecil-tengah">
                                    {mapel.namaMapel}
                                </TableCell>
                            ))}
                            {detail.kelompok != "CAMPURAN" ? (
                                <>
                                    <TableCell className="table-font-kecil-tengah">Total Nilai</TableCell>
                                    <TableCell className="table-font-kecil-tengah">Rata Nilai</TableCell>
                                </>
                            ) : (
                                <>
                                    <TableCell className="table-font-kecil-tengah">Total Nilai</TableCell>
                                    {/* <TableCell className="table-font-kecil-tengah">Rata Saintek</TableCell>
                                    <TableCell className="table-font-kecil-tengah">Rata Soshum</TableCell> */}
                                </>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {siswa.map((sis, sw) => (
                            <TableRow key={sw}>
                                <TableCell className="table-font-kecil">{sw + 1}</TableCell>
                                <TableCell className="table-font-kecil">{sis.namaSiswa}</TableCell>
                                {dataMapel.map((mapel, mp) => dataAll.map((data, j) => mapel.idMapel === data.idMataPelajaran && data.idSiswa === sis.idSiswa && <TableCell className="table-font-kecil-tengah">{data.skor}</TableCell>))}

                                {detail.kelompok != "CAMPURAN" ? (
                                    skorNonCampuran.map(
                                        (listSkor, sk) =>
                                            listSkor.idSiswa === sis.idSiswa && (
                                                <>
                                                    <TableCell className="table-font-kecil-tengah">{listSkor.totSkor}</TableCell>
                                                    <TableCell className="table-font-kecil-tengah">{(listSkor.totSkor / jumMapel).toFixed(2)}</TableCell>
                                                </>
                                            )
                                    )
                                ) : (
                                    <>
                                        {skorNonCampuran.map(
                                            (listSkor, sk) =>
                                                listSkor.idSiswa === sis.idSiswa && (
                                                    <>
                                                        <TableCell className="table-font-kecil-tengah">{listSkor.totSkor}</TableCell>
                                                    </>
                                                )
                                        )}
                                        {/* {skorSaintek.map(
                                            (listSkor, sk) =>
                                                listSkor.idSiswa === sis.idSiswa && (
                                                    <>
                                                        <TableCell className="table-font-kecil-tengah">{(listSkor.totSkor / jumMapel).toFixed(2)}</TableCell>
                                                    </>
                                                )
                                        )}
                                        {skorSoshum.map(
                                            (listSkor, sk) =>
                                                listSkor.idSiswa === sis.idSiswa && (
                                                    <>
                                                        <TableCell className="table-font-kecil-tengah">{(listSkor.totSkor / jumMapel).toFixed(2)}</TableCell>
                                                    </>
                                                )
                                        )} */}
                                    </>
                                )}

                                {/* {
                                            Object.keys(skor).map((sk,skk) => 
                                                <TableCell className="table-font-kecil">{skor[sis.idSiswa]}</TableCell>
                                            )
                                        } */}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            );
        } else {
            return (
                <Row>
                    <Col>
                        <b>Data tidak tersedia</b>
                    </Col>
                </Row>
            );
        }
    }

    render() {
        const { detail } = this.state;
        return (
            <div className="container-fluid" style={{ paddingBottom: "50px" }}>
                <LoaderModal isFetching={this.state.isFetching} />
                <div className="stat-wrapper">
                    <Row>
                        <Col>
                            <div className="header-sbmptn-left">REPORT USS SNBT</div>
                        </Col>
                        <Col>
                            <img src="https://s3edubucket.s3-ap-southeast-1.amazonaws.com/images/logo-eduprime-buildingFL.png" className="header-sbmptn-right" style={{ width: "45%" }} />
                        </Col>
                    </Row>
                    <hr className="garis" />
                    <Row>
                        <Col>
                            <b>{detail.namaJadwal}</b>
                        </Col>
                        <Col>
                            <b style={{ float: "right" }}>
                                {detail.namaSekolah}
                                {/* , {detail.kelompok} */}
                            </b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>{this.renderTableParent()}</Col>
                    </Row>
                    <div id="btn_print">
                        <div className="fixed_button">
                            <button className="btn btn-outline-primary btn133w pull-right" style={{ marginRight: "1em" }} onClick={() => window.print()}>
                                Print
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(SbmptnSekolah);
